import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { DrFileMeta, DrFileMetaCategoryList, FileUploadStatus, DrFileUploadMeta } from '@app/shared/models/dr-file';
import { ContentStoreService } from '@app/core/services/content-store.service';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { AuthenticationService } from '@app/core/authentication';
import { FileActions } from '@app/shared/models/file-actions';
import { CaseFileCategories } from '@app/shared/models/case-file-category';

@Component({
  selector: 'case-files-list',
  templateUrl: './case-files-list.component.html',
  styleUrls: ['./case-files-list.component.scss']
})
export class CaseFilesListComponent extends BaseComponent implements OnInit {

  @Input()
  private caseId: string;

  @Input()
  public smpFileCategory: CaseFileCategories;

  @Input()
  public fileMetaCategoryList: DrFileMetaCategoryList;

  @Input()
  public disabledOptions?: FileActions[];

  @Input()
  public labelProp?: string;

  @Output()
  public fileMetaCategoryListChange = new EventEmitter<DrFileMetaCategoryList>();

  get fileMetaList() {
    return this.fileMetaCategoryList && this.fileMetaCategoryList.getFilesByCategory(this.smpFileCategory);
  }

  constructor(protected contentStoreService: ContentStoreService,
              protected fileUtilityService: FileUtilityService,
              protected authenticationService: AuthenticationService) {
    super();
  }

  public ngOnInit() {
  }

  public viewFile(file: DrFileMeta): void {
    this.fileUtilityService.viewFileInNewTab(file);
  }

  public downloadFile(file: DrFileMeta): void {
    this.fileUtilityService.downloadFile(file);
  }

  protected removeAndReorderFile(file: DrFileMeta) {
    const reorderedFilePatchList = this.fileMetaCategoryList.removeFileMeta(file);

    if (reorderedFilePatchList && reorderedFilePatchList.length > 0) {
      this.contentStoreService.reorderCaseFileMeta(this.caseId, reorderedFilePatchList)
          .subscribe(patchResult => {
            this.fileMetaCategoryList.updateFileMetaOrderAfterSuccessFullPatch(reorderedFilePatchList);
            this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);
          }, err => this.handleError(err));
    } else {
      this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);
    }
  }

  public deleteFile(file: DrFileMeta): void {
    if (file.id) {
      this.contentStoreService.deleteCaseFile(this.caseId, file)
                              .subscribe(result => {
        this.removeAndReorderFile(file);
      }, err => this.handleError(err));
    } else {
      this.removeAndReorderFile(file);
    }
  }

  // Returns true if allowed to delete
  public dynamicDeleteBtnFn(file: DrFileMeta): boolean {
      return file && (!file.creator_role || this.authenticationService.currentUserValue.hasRoles(file.creator_role));
  }

  public editFile(file: DrFileUploadMeta): void {
    this.contentStoreService.editCaseFile(this.caseId, file.fileAsBinaryString, file)
                            .subscribe(result => {
        result.status = FileUploadStatus.READY;
        this.fileMetaCategoryList.replaceFileMetaAfterUpload(result);
        this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);
      },
      err => this.handleError(err)
      );
  }
}
